import React, {memo} from "react";
import {FormHelperText, SvgIcon, TextField} from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {DatePicker, LocalizationProvider} from "@mui/lab";
import "./styles.scss";
import {ja} from 'date-fns/locale';
import {ReactComponent as Calender} from "../../../assets/images/expertSchedule/icon-calendar.svg";

export interface IDatePickerProps {
  id: string;
  value?: any;
  onChange: (date: any) => void;
  label?: React.ReactNode;
  helperText?: string | null;
  minDate?: any;
  disableKeyboardInputs: boolean
  local?: string
}

const DatePickerComponent = ({
                               disableKeyboardInputs,
                               onChange,
                               value,
                               local,
                               label,
                               helperText,
                               minDate,
                             }: IDatePickerProps) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (disableKeyboardInputs) {
      event.preventDefault();
    }
  };

  const DateIcon = (props: any) => {
    return (
      <SvgIcon {...props} className='open_picker_icon'>
        <Calender/>
      </SvgIcon>
    );
  }

  return (
    <div className="date_picker">
      <LocalizationProvider locale={local === "jp" ? ja : ""} dateAdapter={AdapterDateFns}>
        <DatePicker
          components={{
            OpenPickerIcon: DateIcon
          }}
          className={helperText ? "date_picker_error" : ""}
          label={label}
          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField {...params} onKeyDown={onKeyDown}/>}
          minDate={minDate}
        />
        <FormHelperText>{helperText}</FormHelperText>
      </LocalizationProvider>
    </div>
  );
};

export default memo(DatePickerComponent);
